/**
 * Hampers Galore Custom Deferred Optimization Script (assets/hg-custom.js)
 * Consolidates non-critical UI scripts to minimize inline HTML script overhead and achieve sub-100ms INP.
 */

(function() {
  'use strict';

  /* ─────────────────────────────────────────────────────
     1. Mobile Navigation Drawer Tab Lazy-Unwrapping
  ───────────────────────────────────────────────────── */
  function unwrapTab(tabItem) {
    if (!tabItem) return;
    var tmpl = tabItem.querySelector('template');
    if (tmpl && tmpl.content) {
      tabItem.appendChild(tmpl.content.cloneNode(true));
      tmpl.remove();
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('hdt-tab[aria-controls="tab-mobile-custom"] button');
    if (!btn) return;
    var tabGroup = document.getElementById('tab-mobile-custom');
    if (!tabGroup) return;
    var buttons = Array.from(btn.closest('hdt-tab').querySelectorAll('button'));
    var idx = buttons.indexOf(btn);
    if (idx !== -1) {
      var tabItems = tabGroup.querySelectorAll(':scope > .hdt-tab-item');
      if (tabItems[idx]) {
        unwrapTab(tabItems[idx]);
      }
    }
  }, { capture: true });

  /* ─────────────────────────────────────────────────────
     2. Mini-Cart & Cart Drawer Complementary ATC / Sync
  ───────────────────────────────────────────────────── */
  function formatCartMoney(cents) {
    try {
      var fmt = (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.moneyFormat)
        ? window.themeHDN.settings.moneyFormat : '${{amount}}';
      return fmt.replace(/\{\{\s*amount[\w]*\s*\}\}/, (cents / 100).toFixed(2));
    } catch(e) { return '$' + (cents / 100).toFixed(2); }
  }

  function updateBadge(n, totalFormatted) {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart) hdtCart.setAttribute('data-count', n);
    document.querySelectorAll('hdt-cart-count').forEach(function(el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
      if (n > 0) el.removeAttribute('hidden');
    });
    if (totalFormatted) {
      document.querySelectorAll('hdt-cart-total').forEach(function(el) { el.textContent = totalFormatted; });
    }
    ['.hdt-mini-cart__count','.hdt-header__cart-count','[data-cart-count]',
     '[data-header-cart-count]','#cart-icon-bubble','.cart-count-bubble span',
     '.t4s-cart-count','.t4s-cart-icon__count'].forEach(function(s) {
      document.querySelectorAll(s).forEach(function(el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
      });
    });
  }

  function openHDTCart() {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart && typeof hdtCart.open === 'function') { hdtCart.open(); return; }
    var triggers = ['[aria-controls="CartDrawer"]','[data-cart-drawer-trigger]',
      '.hdt-header__cart','.hdt-header__icon--cart','button[data-cart]',
      'a[href="/cart"].hdt-header__icon','.t4s-site-nav__cart > a',
      '[data-t4s-open-quickcart]','[data-open-quickcart]','.t4s-cart-icon a'];
    for (var i = 0; i < triggers.length; i++) {
      var el = document.querySelector(triggers[i]);
      if (el && !el.closest('#CartDrawer') && !el.closest('hdt-cart-drawer')) { el.click(); return; }
    }
    document.dispatchEvent(new CustomEvent('hdt:cart:open', { bubbles: true }));
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateBadge(cart.item_count, formatCartMoney(cart.total_price));
        var hdtCart = document.querySelector('hdt-cart-drawer');
        if (!hdtCart) { openHDTCart(); return; }
        if (typeof hdtCart.renderContents === 'function') { hdtCart.renderContents(); openHDTCart(); return; }
        if (typeof hdtCart.refresh === 'function') { hdtCart.refresh(); openHDTCart(); return; }
        var sectionId = hdtCart.getAttribute('section-id') || 'cart-drawer';
        fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var html = data[sectionId];
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('cart-items-component');
              var live  = document.querySelector('cart-items-component');
              if (fresh && live) live.replaceWith(fresh);
            }
            openHDTCart();
          }).catch(function() { openHDTCart(); });
      }).catch(function() { openHDTCart(); });
  }

  var _compInFlight = {};
  function doCompATC(variantId, card) {
    if (_compInFlight[variantId]) return;
    _compInFlight[variantId] = true;

    var btn         = card ? card.querySelector('.hdt-complementary-atc-btn') : null;
    var spinner     = btn  ? btn.querySelector('.hdt-loading__spinner') : null;
    var icon        = btn  ? btn.querySelector('.hdt-complementary-atc-icon') : null;
    var iconSuccess = btn  ? btn.querySelector('.hdt-complementary-atc-icon--success') : null;

    if (btn)     { btn.disabled = true; btn.setAttribute('data-loading', 'true'); }
    if (spinner) spinner.removeAttribute('hidden');
    if (icon)    icon.setAttribute('hidden', '');

    var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
    .then(function(result) {
      delete _compInFlight[variantId];
      if (spinner) spinner.setAttribute('hidden', '');

      if (result.ok) {
        if (iconSuccess) iconSuccess.removeAttribute('hidden');
        refreshCart();
        setTimeout(function() {
          var slide = card ? (card.closest('.hdt-slider__slide') || card) : null;
          if (slide) slide.remove();
        }, 800);
      } else {
        if (btn)         { btn.disabled = false; btn.removeAttribute('data-loading'); }
        if (icon)        icon.removeAttribute('hidden');
        if (iconSuccess) iconSuccess.setAttribute('hidden', '');
        console.warn('[Complementary ATC] Failed:', (result.data.description || result.data.message));
      }
    })
    .catch(function(err) {
      delete _compInFlight[variantId];
      if (spinner)     spinner.setAttribute('hidden', '');
      if (btn)         { btn.disabled = false; btn.removeAttribute('data-loading'); }
      if (icon)        icon.removeAttribute('hidden');
      if (iconSuccess) iconSuccess.setAttribute('hidden', '');
      console.error('[Complementary ATC] Network error:', err);
    });
  }

  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-complementary-atc]');
    if (!el) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId   = el.getAttribute('data-variant-id');
    var isAvailable = el.getAttribute('data-available');
    if (!variantId || isAvailable === 'false') return;

    var card = el.closest('.hdt-minicart-recommendations__item');
    if (!card) return;

    var btn = card.querySelector('.hdt-complementary-atc-btn');
    if (btn && btn.getAttribute('data-loading')) return;

    doCompATC(variantId, card);
  }, true);

  /* ─────────────────────────────────────────────────────
     3. Urgency Countdown Timers & Coupon Copy
  ───────────────────────────────────────────────────── */
  function initUrgencyTimers() {
    document.querySelectorAll('.tb-offer-timer, .hg-offer-timer').forEach(function(wrap) {
      if (wrap._hgTimerInit) return;
      wrap._hgTimerInit = true;
      var duration = parseInt(wrap.dataset.duration) || 0;
      var remaining = duration;

      function updateTimer() {
        if (remaining <= 0) remaining = duration;
        var days = Math.floor(remaining / 86400);
        var hours = Math.floor((remaining % 86400) / 3600);
        var minutes = Math.floor((remaining % 3600) / 60);
        var seconds = remaining % 60;

        var dEl = wrap.querySelector('[data-days]');
        var hEl = wrap.querySelector('[data-hours]');
        var mEl = wrap.querySelector('[data-minutes]');
        var sEl = wrap.querySelector('[data-seconds]');

        if (dEl) dEl.innerHTML = String(days).padStart(2, '0');
        if (hEl) hEl.innerHTML = String(hours).padStart(2, '0');
        if (mEl) mEl.innerHTML = String(minutes).padStart(2, '0');
        if (sEl) sEl.innerHTML = String(seconds).padStart(2, '0');
        remaining--;
      }
      updateTimer();
      setInterval(updateTimer, 1000);
    });
  }

  document.addEventListener('click', function(e) {
    var offer = e.target.closest('.tb-offer, .hg-offer');
    if (!offer) return;
    var code = offer.dataset.code;
    if (code && navigator.clipboard) {
      navigator.clipboard.writeText(code);
      offer.classList.add('copied');
      setTimeout(function() { offer.classList.remove('copied'); }, 1200);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUrgencyTimers);
  } else {
    initUrgencyTimers();
  }

  /* ─────────────────────────────────────────────────────
     4. High-Speed Direct Add-To-Cart Delegate (.gba-atc, .gba-card-atc, INP < 100ms)
  ───────────────────────────────────────────────────── */
  var _gbaInFlight = {};
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.gba-atc, .gba-card-atc');
    if (!btn || btn.getAttribute('data-loading') === 'true' || btn.disabled) return;

    var vid = btn.dataset.vid;
    if (!vid) return;

    e.preventDefault();
    e.stopPropagation();

    if (_gbaInFlight[vid]) return;
    _gbaInFlight[vid] = true;

    // Fast, synchronous visual feedback to guarantee sub-50ms INP
    btn.setAttribute('data-loading', 'true');
    btn.classList.add('loading');
    var txtEl = btn.querySelector('.gba-atc-txt') || btn.querySelector('.hdt-truncate');
    var origTxt = btn.getAttribute('data-orig-txt') || (txtEl ? txtEl.textContent : '');
    if (txtEl) {
      if (!btn.getAttribute('data-orig-txt')) btn.setAttribute('data-orig-txt', origTxt);
      txtEl.textContent = 'Adding\u2026';
    }

    var qty = parseInt(btn.dataset.qty || 1, 10);
    var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || d.message || 'Error'); });
      return r.json();
    })
    .then(function() {
      delete _gbaInFlight[vid];
      btn.classList.remove('loading');
      btn.classList.add('ok');
      if (txtEl) txtEl.textContent = '\u2713 Added!';
      refreshCart();
      setTimeout(function() {
        btn.removeAttribute('data-loading');
        btn.classList.remove('ok');
        if (txtEl) txtEl.textContent = btn.getAttribute('data-orig-txt') || 'Add to Cart';
      }, 2000);
    })
    .catch(function(err) {
      delete _gbaInFlight[vid];
      btn.removeAttribute('data-loading');
      btn.classList.remove('loading');
      if (txtEl) txtEl.textContent = btn.getAttribute('data-orig-txt') || 'Add to Cart';
      alert(err.message || 'Could not add item.');
    });
  }, true /* capture phase for sub-100ms INP */);




  

})();
// **********************************************************************************************************************************************************************//

// custom cart cyo 
// Function to disable CYO product links in both cart drawer and cart page
// Function to remove href attributes from CYO products
// custom cart cyo
(function () {

  function isCYOorBulk(item) {
    // New theme selectors
    const titleLink = item.querySelector('.hdt-mini-cart__title, .hdt-page-cart__title');
    const hasBoxProperty = item.querySelector('.hdt-product-details__item-label span');

    if (titleLink) {
      const titleText = titleLink.textContent.trim();
      if (titleText.startsWith('CYO') || titleText.includes('Bulk')) return true;
    }
    if (hasBoxProperty && hasBoxProperty.textContent.trim() === 'Box:') return true;

    return false;
  }

  function disableLinks(item) {
    // Disable title link
    const titleLink = item.querySelector('.hdt-mini-cart__title, .hdt-page-cart__title');
    if (titleLink) {
      titleLink.removeAttribute('href');
      titleLink.style.cursor = 'default';
      titleLink.style.textDecoration = 'none';
      titleLink.style.pointerEvents = 'none';
    }

    // Disable image link
    const imageLink = item.querySelector('.hdt-mini-cart__img, .hdt-page-cart__img');
    if (imageLink) {
      imageLink.removeAttribute('href');
      imageLink.style.cursor = 'default';
      imageLink.style.pointerEvents = 'none';
    }
  }

  function removeCYOProductHrefs() {
    // New theme cart item selectors
    const cartItems = document.querySelectorAll('hdt-line-item');
    cartItems.forEach(item => {
      if (isCYOorBulk(item)) {
        disableLinks(item);
      }
    });
  }

  // ✅ Single bulletproof observer on document.body
  new MutationObserver(function () {
    removeCYOProductHrefs();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

  // ✅ Block ALL clicks as backup (capturing phase)
  document.addEventListener('click', function (e) {
    const cartItem = e.target.closest('hdt-line-item');
    if (cartItem && isCYOorBulk(cartItem)) {
      // Only block clicks on title/image links, not remove/quantity buttons
      const isTitle = e.target.closest('.hdt-mini-cart__title, .hdt-page-cart__title');
      const isImage = e.target.closest('.hdt-mini-cart__img, .hdt-page-cart__img');
      if (isTitle || isImage) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }
  }, true);

  // ✅ Initial runs
  document.addEventListener('DOMContentLoaded', removeCYOProductHrefs);
  setTimeout(removeCYOProductHrefs, 300);
  setTimeout(removeCYOProductHrefs, 800);
  setTimeout(removeCYOProductHrefs, 1500);

  // ✅ Cart events
  document.addEventListener('cart:updated', removeCYOProductHrefs);
  document.addEventListener('cart:refresh', removeCYOProductHrefs);

})();
// custom cart cyo -end  
//cyo bundle creator easify app js

(function () {
  const STEP = 10;

  // ─── Selectors (stable hooks, not the random module classes) ────────────────
  const GRID_SELECTOR   = '.cyo-product-grid-wapper';
  const CARD_SELECTOR   = '[data-product-id][data-variant-ids]';
  const TITLE_SELECTOR  = '.PRODUCT_CARD_TITLE_TS';
  const ACCORDION_SELECTOR = '[class*="accordionElement-module__accordionContentItem"]';

  const EXCLUDED_WORDS = ['cyo', 'voucher', 'egift', 'create your own'];

  const gridsState = new Map();
  let isPaused = false;

  function getTitleText(product) {
    const titleEl = product.querySelector(TITLE_SELECTOR);
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function isTitleLoaded(product) {
    return getTitleText(product) !== '';
  }

  function isExcluded(product) {
    if (product.getAttribute('data-excluded') === 'true') return true;

    // Hidden by something else (not by this script)
    const inlineDisplay = product.style.display;
    if (!inlineDisplay) {
      if (window.getComputedStyle(product).display === 'none') return true;
    }

    const title = getTitleText(product).toLowerCase();
    if (!title) return false;
    return EXCLUDED_WORDS.some(word => title.includes(word));
  }

  function getAllProducts(gridWrapper) {
    return Array.from(gridWrapper.querySelectorAll(CARD_SELECTOR));
  }

  function getEligibleProducts(gridWrapper) {
    return getAllProducts(gridWrapper).filter(
      p => p.getAttribute('data-excluded') !== 'true'
    );
  }

  function hideExcludedProducts(gridWrapper) {
    getAllProducts(gridWrapper).forEach(product => {
      if (product.getAttribute('data-excluded') === 'true') return;
      if (isExcluded(product)) {
        product.style.display = 'none';
        product.setAttribute('data-excluded', 'true');
      }
    });
  }

  function applyVisibility(gridWrapper, visibleItems) {
    getEligibleProducts(gridWrapper).forEach((product, index) => {
      product.style.display = index < visibleItems ? '' : 'none';
    });
  }

  function updateButtonVisibility(gridWrapper, state) {
    if (!state.btnElement) return;
    const eligible = getEligibleProducts(gridWrapper);

    // Show button only if there are still hidden products
    state.btnElement.style.display =
      eligible.length > state.visibleItems ? 'block' : 'none';
  }

  function waitForTitles(gridWrapper, callback) {
    const maxWait = 10000;
    const interval = 100;
    let elapsed = 0;

    const check = setInterval(() => {
      const allProducts = getAllProducts(gridWrapper);
      const allTitlesLoaded =
        allProducts.length > 0 && allProducts.every(isTitleLoaded);

      elapsed += interval;
      if (allTitlesLoaded || elapsed >= maxWait) {
        clearInterval(check);
        callback();
      }
    }, interval);
  }

  function createLoadMoreButton(gridWrapper, state) {
    const btnWrapper = document.createElement('div');
    btnWrapper.className = 'cyo-load-more-wrapper';
    btnWrapper.style.cssText =
      'text-align:center; margin: 30px 0; width:100%; clear:both;';

    btnWrapper.innerHTML = `
      <button type="button" class="cyo-load-more-btn" style="cursor:pointer; padding: 12px 35px; z-index:9 !important; background:#000; color:#fff; border:none; border-radius:4px; font-weight:bold; font-size:16px;">
        Load More Products
      </button>`;

    const btn = btnWrapper.querySelector('button');

    btn.addEventListener('click', e => {
      e.preventDefault();
      if (btn.disabled) return;

      btn.disabled = true;
      isPaused = true;

      hideExcludedProducts(gridWrapper);
      state.visibleItems += STEP;
      applyVisibility(gridWrapper, state.visibleItems);

      btn.disabled = false;
      isPaused = false;
      updateButtonVisibility(gridWrapper, state);
    });

    return btnWrapper;
  }

  function initGrid(gridWrapper) {
    if (!gridsState.has(gridWrapper)) {
      gridsState.set(gridWrapper, {
        visibleItems: STEP,
        btnElement: null,
        waitingForTitles: false
      });
    }

    const state = gridsState.get(gridWrapper);

    if (state.waitingForTitles) return;
    state.waitingForTitles = true;

    waitForTitles(gridWrapper, () => {
      state.waitingForTitles = false;

      hideExcludedProducts(gridWrapper);

      const eligible = getEligibleProducts(gridWrapper);
      if (eligible.length === 0) return;

      applyVisibility(gridWrapper, state.visibleItems);

      // Add the button (or re-add it if the app re-rendered and removed it)
      const buttonMissing = !state.btnElement || !state.btnElement.isConnected;
      if (eligible.length > STEP && buttonMissing) {
        state.btnElement = createLoadMoreButton(gridWrapper, state);
        gridWrapper.after(state.btnElement);
      }

      updateButtonVisibility(gridWrapper, state);
    });
  }

  function initAll() {
    document.querySelectorAll(GRID_SELECTOR).forEach(initGrid);
  }

  // ─── MutationObserver ───────────────────────────────────────────────────────
  let debounceTimer;
  const observer = new MutationObserver(() => {
    if (isPaused) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initAll, 200);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ─── Start ──────────────────────────────────────────────────────────────────
  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }
})();
// ─── Shared selectors (stable hooks, not the random module classes) ──────────
const GRID_SEL      = '.cyo-product-grid-wapper';
const CARD_SEL      = '[data-product-id][data-variant-ids]';
const TITLE_SEL     = '.PRODUCT_CARD_TITLE_TS';
const ATC_BTN_SEL   = '.PRODUCT_CARD_ATC_BUTTON_TS';
const VIEW_BTN_SEL  = '.PRODUCT_CARD_VIEW_BUTTON_TS';
const ATC_AREA_SEL  = '[class*="add_to_box_actions"]';

// add to box button trigger on product card
document.addEventListener('click', function (e) {
  const productCard = e.target.closest(GRID_SEL + ' ' + CARD_SEL);
  if (!productCard) return;

  const isExcluded =
    e.target.closest(ATC_BTN_SEL) ||      // the Add to Box button itself (also prevents loops)
    e.target.closest(ATC_AREA_SEL) ||     // the whole Add to Box overlay area
    e.target.closest(VIEW_BTN_SEL) ||     // quick view icon
    e.target.closest(GRID_SEL + ' a') ||
    e.target.closest(GRID_SEL + ' button');

  if (isExcluded) return;

  const addToBoxBtn = productCard.querySelector(ATC_BTN_SEL);
  if (addToBoxBtn) {
    addToBoxBtn.dispatchEvent(new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    }));
  }
});

// Bulk radio: don't allow un-checking an already checked radio
// (delegated, so it works even if #tb-bulk-radio renders later)
document.addEventListener('mousedown', function (e) {
  const radio = e.target.closest('#tb-bulk-radio input[type="radio"]');
  if (radio && radio.checked) {
    e.preventDefault();
  }
});

//bulk app
(function () {
  function injectDownloadButton() {
    const multiAddress = document.getElementById('tb-bulk-multi-address');
    if (!multiAddress) return;

    // Avoid duplicate injection
    if (multiAddress.querySelector('.multi-address-downlaod-wapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'multi-address-downlaod-wapper';

    const link = document.createElement('a');
    link.href = 'https://cdn.shopify.com/s/files/1/0517/2061/8175/files/Hampers_Galore_Corporate_Bulk_Order_Form--2026.xlsx?v=1788434334';
    link.className = 'cgb-download-template-btn';
    link.setAttribute('download', '');
    link.textContent = 'Download bulk order form (Excel)';

    wrapper.appendChild(link);
    multiAddress.appendChild(wrapper);
  }

  const observer = new MutationObserver(injectDownloadButton); // keeps working on SPA navigation
  observer.observe(document.body, { childList: true, subtree: true });

  injectDownloadButton(); // initial attempt
})();

// next button configuration – hide CYO / voucher / eGift products
(function () {
  const EXCLUDED_WORDS = ['cyo', 'voucher', 'egift', 'create your own'];

  function hideCYOProducts() {
    const productCards = document.querySelectorAll('.gba-bulk-accodian ' + CARD_SEL);
    productCards.forEach(function (card) {
      if (card.getAttribute('data-excluded') === 'true') return;

      const titleEl = card.querySelector(TITLE_SEL);
      if (!titleEl) return;

      const titleText = titleEl.textContent.trim().toLowerCase();
      if (EXCLUDED_WORDS.some(word => titleText.includes(word))) {
        card.style.display = 'none';
        card.setAttribute('data-excluded', 'true'); // so the Load More script skips it too
      }
    });
  }

  function init() {
    hideCYOProducts();

    let timer;
    const observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(hideCYOProducts, 150); // debounce
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// review page
(function () {
  function toggleReviewState() {
    const reviewHeader = document.getElementById('Review-bulk-order-header');
    document.body.classList.toggle('review-summery', !!reviewHeader);
  }

  toggleReviewState();

  const observer = new MutationObserver(toggleReviewState);
  observer.observe(document.body, { childList: true, subtree: true });
})();

//cyo bundle creator easify app js - end

// trigger add to cart when click mini cart
document.addEventListener('click', function (e) {
  const stickyBtn = e.target.closest('.hdt-sticky-atc__submit');
  if (stickyBtn) {
    e.preventDefault();
    e.stopPropagation();

    // Create and inject spinner overlay
    const spinnerOverlay = document.createElement('span');
    spinnerOverlay.style.cssText = `
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: inherit;
      border-radius: inherit;
      pointer-events: none;
    `;
    spinnerOverlay.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"
        style="animation: hdtSpin 0.8s linear infinite;">
        <circle fill="none" stroke="currentColor" stroke-width="6" cx="33" cy="33" r="30"
          stroke-dasharray="80, 200" stroke-linecap="round"/>
      </svg>
    `;

    // Add keyframe animation once
    if (!document.getElementById('hdt-spin-style')) {
      const style = document.createElement('style');
      style.id = 'hdt-spin-style';
      style.textContent = `@keyframes hdtSpin { to { transform: rotate(360deg); } }`;
      document.head.appendChild(style);
    }

    stickyBtn.style.pointerEvents = 'none';
    stickyBtn.appendChild(spinnerOverlay);

    // Remove spinner after 3s
    setTimeout(function () {
      spinnerOverlay.remove();
      stickyBtn.style.pointerEvents = '';
    }, 3000);

    const mainBtn = document.querySelector('.hdt-product-form__submit');
    if (mainBtn) mainBtn.click();
  }
}, true);

// Sticky add to cart: keep sticky + main product forms in sync (qty, variant).
function getStickyProductForms() {
  const stickyAtc = document.querySelector('hdt-sticky-btn-atc');
  const stickyForm = document.querySelector('.hdt-sticky-atc__form');
  if (!stickyAtc || !stickyForm) return null;

  const mainFormId = stickyAtc.getAttribute('form');
  const mainForm = mainFormId ? document.getElementById(mainFormId) : document.querySelector('.hdt-main-product-form');
  if (!mainForm) return null;

  return { stickyForm, mainForm };
}

function syncProductFormField(stickyForm, mainForm, fieldName) {
  const stickyField = stickyForm.querySelector(`[name="${fieldName}"]`);
  const mainField = mainForm.querySelector(`[name="${fieldName}"]`);
  if (!stickyField || !mainField) return;

  mainField.value = stickyField.value;
  if (mainField.disabled) mainField.disabled = false;
}

function syncMainProductFormFromSticky() {
  const forms = getStickyProductForms();
  if (!forms) return;
  syncProductFormField(forms.stickyForm, forms.mainForm, 'quantity');
  syncProductFormField(forms.stickyForm, forms.mainForm, 'id');
}

function syncStickyProductFormFromMain() {
  const forms = getStickyProductForms();
  if (!forms) return;
  syncProductFormField(forms.mainForm, forms.stickyForm, 'quantity');
  syncProductFormField(forms.mainForm, forms.stickyForm, 'id');
}

function clampStickyQuantityInput(input) {
  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || parseInt(input.dataset.max, 10) || 9999;
  const step = parseInt(input.step, 10) || 1;
  let value = parseInt(input.value, 10) || min;
  value = Math.max(min, Math.min(max, value));
  if (step > 1) {
    value = min + Math.round((value - min) / step) * step;
    value = Math.max(min, Math.min(max, value));
  }
  input.value = value;
  const minusBtn = input.closest('hdt-quantity-wrapp')?.querySelector('.hdt-quantity__button[name="minus"]');
  const plusBtn = input.closest('hdt-quantity-wrapp')?.querySelector('.hdt-quantity__button[name="plus"]');
  if (minusBtn) minusBtn.classList.toggle('disabled', value <= min);
  if (plusBtn) plusBtn.classList.toggle('disabled', value >= max);
}

function initStickyProductQuantity() {
  const forms = getStickyProductForms();
  if (!forms || forms.stickyForm.dataset.tbQtySync === 'true') return;
  forms.stickyForm.dataset.tbQtySync = 'true';

  const stickyQty = forms.stickyForm.querySelector('input[name="quantity"]');
  const mainQty = forms.mainForm.querySelector('input[name="quantity"]');

  if (stickyQty) {
    clampStickyQuantityInput(stickyQty);
    stickyQty.addEventListener('change', function () {
      clampStickyQuantityInput(stickyQty);
      syncProductFormField(forms.stickyForm, forms.mainForm, 'quantity');
    });
  }

  if (mainQty) {
    mainQty.addEventListener('change', function () {
      syncProductFormField(forms.mainForm, forms.stickyForm, 'quantity');
      if (stickyQty) clampStickyQuantityInput(stickyQty);
    });
  }

  const onVariantChange = function () {
    syncStickyProductFormFromMain();
    if (stickyQty) clampStickyQuantityInput(stickyQty);
  };

  forms.mainForm.addEventListener('variant:change', onVariantChange);
  forms.stickyForm.addEventListener('variant:change', onVariantChange);
}

function handleStickyQuantityButtonClick(event) {
  const button = event.target.closest('.hdt-sticky-atc__qty-selector .hdt-quantity__button');
  if (!button) return;

  const forms = getStickyProductForms();
  if (!forms) return;

  const input = forms.stickyForm.querySelector('input[name="quantity"]');
  if (!input) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const step = parseInt(input.step, 10) || 1;
  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || parseInt(input.dataset.max, 10) || 9999;
  let value = parseInt(input.value, 10) || min;

  if (button.name === 'plus') {
    value = Math.min(value + step, max);
  } else if (button.name === 'minus') {
    value = Math.max(value - step, min);
  }

  input.value = value;
  clampStickyQuantityInput(input);
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function initStickyAtcInteractions() {
  initStickyProductQuantity();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyAtcInteractions);
} else {
  initStickyAtcInteractions();
}
document.addEventListener('shopify:section:load', initStickyAtcInteractions);

document.addEventListener('click', handleStickyQuantityButtonClick, true);

// Sticky add to cart uses the main form handler after syncing sticky values.
document.addEventListener('click', function (e) {
  const stickyBtn = e.target.closest('.hdt-sticky-atc__submit');
  if (stickyBtn) {
    e.preventDefault();
    e.stopPropagation();

    syncMainProductFormFromSticky();

    const spinnerOverlay = document.createElement('span');
    spinnerOverlay.style.cssText = `
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: inherit;
      border-radius: inherit;
      pointer-events: none;
    `;
    spinnerOverlay.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"
        style="animation: hdtSpin 0.8s linear infinite;">
        <circle fill="none" stroke="currentColor" stroke-width="6" cx="33" cy="33" r="30"
          stroke-dasharray="80, 200" stroke-linecap="round"/>
      </svg>
    `;

    if (!document.getElementById('hdt-spin-style')) {
      const style = document.createElement('style');
      style.id = 'hdt-spin-style';
      style.textContent = `@keyframes hdtSpin { to { transform: rotate(360deg); } }`;
      document.head.appendChild(style);
    }

    stickyBtn.style.pointerEvents = 'none';
    stickyBtn.appendChild(spinnerOverlay);

    setTimeout(function () {
      spinnerOverlay.remove();
      stickyBtn.style.pointerEvents = '';
    }, 3000);

    const mainBtn = document.querySelector('.hdt-product-form__submit');
    if (mainBtn) mainBtn.click();
  }
}, true);





// INP FIX #1 v3 - Product Card Add to Cart (gba-card-atc)
// TARGET: < 180ms INP on mobile, < 100ms on desktop
//
// HOW SUB-180ms INP IS ACHIEVED:
//
//   INP = time from user interaction (click/tap) to next browser paint.
//
//   STEP 1 [SYNCHRONOUS ~1ms]:
//     btn.disabled = true  - only DOM work in the click handler.
//     CSS :disabled handles all visuals (no class changes, no text mutations).
//
//   STEP 2 [YIELD - lets browser paint]:
//     scheduler.yield() (Chrome 115+) or Promise.resolve() fallback.
//     Browser commits a paint frame showing the :disabled button.
//     INP is measured to THIS paint. Done. ~5-20ms desktop, ~20-50ms mobile.
//
//   STEP 3 [ASYNC - after paint]:
//     fetch('/cart/add.js') runs. Never blocks the main thread.
//     Success: .ok CSS class + Added! text + refreshCart().
//     These run ~200-400ms after click - well outside the INP window.
//
//   MOBILE EXTRA: touch-action: manipulation on the button (hg-custom.css)
//     eliminates the 300ms double-tap-zoom delay on iOS Safari.
//     Without it, mobile INP cannot be < 300ms regardless of JS speed.

(function () {
  'use strict';

  // Yield helper: Chrome 115+ native, or Promise.resolve() micro-task fallback
  function _yield() {
    if (typeof scheduler !== 'undefined' && typeof scheduler.yield === 'function') {
      return scheduler.yield();
    }
    return Promise.resolve();
  }

  // Cart badge update - mirrors gift-finder updateBadge exactly
  function _cardAtcUpdateBadge(n, totalFormatted) {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart) hdtCart.setAttribute('data-count', n);
    document.querySelectorAll('hdt-cart-count').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
      else { el.style.display = 'none'; }
    });
    if (totalFormatted) {
      document.querySelectorAll('hdt-cart-total').forEach(function (el) { el.textContent = totalFormatted; });
    }
    var sels = ['.hdt-mini-cart__count', '.hdt-header__cart-count', '[data-cart-count]',
      '[data-header-cart-count]', '#cart-icon-bubble', '.cart-count-bubble span'];
    sels.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { el.textContent = n; });
    });
  }

  // Money formatter - mirrors gift-finder formatCartMoney exactly
  function _cardAtcFormatMoney(cents) {
    try {
      var fmt = (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.moneyFormat)
        ? window.themeHDN.settings.moneyFormat : '${{amount}}';
      return fmt.replace(/\{\{\s*amount[\w]*\s*\}\}/, (cents / 100).toFixed(2));
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  // Open cart drawer - mirrors gift-finder openHDTCart exactly
  function _cardAtcOpenCart() {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart && typeof hdtCart.open === 'function') { hdtCart.open(); return; }
    var trigSels = ['[aria-controls="CartDrawer"]', '[data-cart-drawer-trigger]',
      '.hdt-header__cart', '.hdt-header__icon--cart', 'button[data-cart]',
      'a[href="/cart"].hdt-header__icon'];
    for (var i = 0; i < trigSels.length; i++) {
      var el = document.querySelector(trigSels[i]);
      if (el && !el.closest('#CartDrawer') && !el.closest('hdt-cart-drawer')) { el.click(); return; }
    }
    document.dispatchEvent(new CustomEvent('hdt:cart:open', { bubbles: true }));
  }

  // Refresh cart drawer + badge - mirrors gift-finder refreshCart exactly
  function _cardAtcRefreshCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _cardAtcUpdateBadge(cart.item_count, _cardAtcFormatMoney(cart.total_price));
        var hdtCart = document.querySelector('hdt-cart-drawer');
        if (!hdtCart) { _cardAtcOpenCart(); return; }
        if (typeof hdtCart.renderContents === 'function') { hdtCart.renderContents(); _cardAtcOpenCart(); return; }
        if (typeof hdtCart.refresh === 'function') { hdtCart.refresh(); _cardAtcOpenCart(); return; }
        var sectionId = hdtCart.getAttribute('section-id') || 'cart-drawer';
        fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[sectionId] || null;
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('cart-items-component');
              var live = document.querySelector('cart-items-component');
              if (fresh && live) live.replaceWith(fresh);
            }
            _cardAtcOpenCart();
          })
          .catch(function () { _cardAtcOpenCart(); });
      })
      .catch(function () { _cardAtcOpenCart(); });
  }

  // Single delegated click listener for ALL product card ATC buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gba-card-atc[data-vid]');
    if (!btn || btn.disabled) return;

    var vid = btn.dataset.vid;
    var qty = parseInt(btn.dataset.qty || 1, 10);
    if (!vid) return;

    // DOM READ (synchronous) -- querySelector is a pure read, no reflow/paint.
    // Cache here so all promise callbacks can reference it without re-querying.
    var txtSpan = btn.querySelector('.hdt-truncate');
    var origText = txtSpan ? (txtSpan.dataset.originalText || txtSpan.textContent) : '';
    if (txtSpan && origText) txtSpan.dataset.originalText = origText;

    // STEP 1: Single synchronous DOM WRITE — triggers :disabled repaint.
    // CSS :disabled { opacity:0.65; cursor:not-allowed } handles visual feedback.
    // INP = click to this paint. No extra class, no text change here.
    btn.disabled = true;

    // STEP 2: Yield — browser commits the :disabled paint frame.
    // INP is measured to THAT paint (~5-20ms desktop, ~20-50ms mobile).
    // Everything after this point is outside the INP measurement window.
    _yield()
      .then(function () {
        // "Adding..." runs AFTER the INP paint frame — user sees it in the very
        // next frame (~16ms after click) but does NOT count toward INP score.
        if (txtSpan) txtSpan.textContent = 'Adding\u2026';

        // STEP 3: Fetch — fully async, never blocks main thread.
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        // Success -- ~200-400ms after click (well outside INP window).
        btn.classList.add('ok');
        if (txtSpan) txtSpan.textContent = '\u2713 Added!';
        _cardAtcRefreshCart();
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('ok');
          if (txtSpan) txtSpan.textContent = origText;
        }, 2200);
      })
      .catch(function (err) {
        // Error -- re-enable and restore original label.
        btn.disabled = false;
        if (txtSpan) txtSpan.textContent = origText;
        var msg = (err && err.description) ? err.description
          : (err && err.message) ? err.message
            : 'Could not add item. Please try again.';
        alert(msg);
      });

  });

}());
// END INP FIX #1 v3


// -------------------------------------------------------------
// Mobile 2x2 Facet Dropdowns UX (Devices <= 1024px)
// Handles: Exclusive opening, Click-outside dismissal,
// 'Done' / Close button handling, and Price submit dismissal.
// -------------------------------------------------------------
(function initMobileFacetDropdowns() {
  document.addEventListener('click', function(e) {
    // 1. Close button or Done button
    const closeBtn = e.target.closest('[data-close-dropdown]');
    if (closeBtn) {
      const details = closeBtn.closest('.hg-facet-dropdown');
      if (details) {
        e.preventDefault();
        details.removeAttribute('open');
      }
      return;
    }

    // 2. Price apply button submit: close price dropdown so results are cleanly displayed
    const priceApplyBtn = e.target.closest('.hg-price-range-wrap wrapp-hdt-btn-submit-filter');
    if (priceApplyBtn) {
      const details = priceApplyBtn.closest('.hg-facet-dropdown');
      if (details) {
        setTimeout(function() {
          details.removeAttribute('open');
        }, 50);
      }
      return;
    }

    // 3. Exclusive accordion behavior when opening another dropdown
    const summary = e.target.closest('.hg-facet-dropdown > summary');
    if (summary) {
      const parentDetails = summary.parentElement;
      document.querySelectorAll('.hg-facet-dropdown[open]').forEach(function(details) {
        if (details !== parentDetails) {
          details.removeAttribute('open');
        }
      });
      return;
    }

    // 4. Click outside open dropdowns: dismiss them
    const openDropdown = document.querySelector('.hg-facet-dropdown[open]');
    if (openDropdown && !openDropdown.contains(e.target)) {
      openDropdown.removeAttribute('open');
    }
  }, true);

  // Close on Escape key
    // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.hg-facet-dropdown[open]').forEach(function(details) {
        details.removeAttribute('open');
      });
    }
  });
})();
